import { bl_fi_aging_period_line_RowClass } from 'blg-akaun-ts-lib';

export interface AgingPeriodState {
    selectedAgingPeriod: any;
    lines: bl_fi_aging_period_line_RowClass []
}


export const initialState: AgingPeriodState = {
    selectedAgingPeriod: null,
    lines: []
}
